import type { AuditType } from '@ifs-gcp/core/models';

// Map audit types to their corresponding template IDs
// currently only 'main-audit' has a template, the others are placeholders for future templates
export const TEMPLATES_MAP: Record<AuditType, string> = {
  'main-audit': 'AXPX_AUDIT_ONLINE_MAIN_GENERAL',
  'follow-up-audit': '',
  'extension-audit': '',
};
